import { GetUserRolloverDTO } from "../../../api-client-nswag/taxportal-client";

export interface NotificationSettings {
    notifyClient: boolean;
    firstEmail: boolean;
    secondEmail: boolean;
    secondEmailDays: number | undefined;
    cancelationEmail: boolean;
}

export interface NotificationPreferencesProps {
    settings: NotificationSettings;
    scheduledDate?: Date | string;
    onSettingsChange?: (updater: NotificationSettings | ((prev: NotificationSettings) => NotificationSettings)) => void;
    disabled?: boolean;
    // New callback: notifies parent whether notification settings are valid
    onValidationChange?: (isValid: boolean) => void;
    isReadOnly?: boolean;
    selectedRolloverItem?: GetUserRolloverDTO
}

export const DEFAULT_NOTIFICATION_SETTINGS: NotificationSettings = {
    notifyClient: true,
    firstEmail: true,
    secondEmail: false,
    secondEmailDays: undefined,
    cancelationEmail: false,
};